import { PiggyBank } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { formatCurrency } from "web_myplann/Infrastructure/Utils/CurrencyUtils";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import { INSPIRATION_CURRENCY } from "web_myplann/Inspiration/constants";
import type { OwnHomeContext } from "web_myplann/Inspiration/Utils/ownHomeMath";
import { Callout } from "web_myplann/Shared/Components/Callout";

const R = Resources.Inspiration.OwnHome.Result;

type Props = {
	context: OwnHomeContext;
};

export const DownPaymentSection: FC<Props> = ({ context }) => {
	const { t } = useResource();

	const gap = context.savingsGap ?? 0;

	return (
		<InspirationSection title={t(R.downPaymentTitle)}>
			<Callout
				color="amber"
				icon={PiggyBank}
				title={t(R.downPaymentHeading, {
					gap: formatCurrency(gap, INSPIRATION_CURRENCY, 0),
				})}
				description={t(R.downPaymentText, {
					downPayment: formatCurrency(
						context.downPayment,
						INSPIRATION_CURRENCY,
						0,
					),
					savings: formatCurrency(context.savings, INSPIRATION_CURRENCY, 0),
				})}
			/>
		</InspirationSection>
	);
};
